import React from "react";
import JsonView from '@uiw/react-json-view';
import { jsonViewCustomTheme } from "config/constants";

const SwaggerDoc = ({ swaggerDoc }) => {
    // Handle null, undefined, or empty swaggerDoc
    if (!swaggerDoc || (typeof swaggerDoc === 'object' && Object.keys(swaggerDoc).length === 0)) {
        return (
            <div className="h-full p-4 bgPrimary flex items-center justify-center">
                <div className="text-center text-[var(--text-secondary)]">
                    <div className="text-lg font-medium mb-2">No Swagger Documentation Available</div>
                </div>
            </div>
        );
    }

    return (
        <div className="h-full p-2 bgPrimary overflow-y-auto text-[var(--text-primary)]">
            <JsonView
                value={swaggerDoc}
                displayDataTypes={false}
                displayObjectSize={false}
                displayArrayKey={false}
                enableClipboard={false}
                style={jsonViewCustomTheme}
            />
        </div>
    );
};

export default SwaggerDoc;
